import React from "react";
import { Helmet } from "react-helmet-async";

export default function LoanOffers() {
  return (
    <>
      <Helmet>
        <title>Best Bike Loan Offers India 2026 | Low EMI & Fast Approval | MotoHub India</title>

        <meta
          name="description"
          content="Compare best bike loan offers in India from HDFC, Axis, Bajaj Finance & more. Get lowest interest rates, quick approval, and affordable EMI plans."
        />

        <meta
          name="keywords"
          content="bike loan India, two wheeler loan India, bike EMI offers, best bike finance India, low interest bike loan, motorcycle loan India"
        />

        <link rel="canonical" href="https://motohubindia.com/loan-offers" />

        {/* Open Graph */}
        <meta property="og:title" content="Best Bike Loan Offers in India | MotoHub India" />
        <meta property="og:description" content="Compare bike loan interest rates and EMI plans from top banks and NBFCs." />
        <meta property="og:image" content="https://motohubindia.com/logo.png" />
        <meta property="og:url" content="https://motohubindia.com/loan-offers" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bike Loan Deals India" />
        <meta name="twitter:description" content="Find lowest EMI and best bike loan offers in India." />
        <meta name="twitter:image" content="https://motohubindia.com/logo.png" />

        {/* SEO */}
        <meta name="robots" content="index, follow" />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FinancialProduct",
            name: "Bike Loan Offers India",
            description: "Compare two wheeler loan offers from top banks and NBFCs.",
            provider: {
              "@type": "Organization",
              name: "MotoHub India",
            },
            offers: {
              "@type": "AggregateOffer",
              lowPrice: "8.5",
              highPrice: "12",
              priceCurrency: "INR",
            },
          })}
        </script>
      </Helmet>

      <div style={{ padding: "30px" }}>
        <h1 style={title}>💰 Best Bike Loan Offers</h1>

        {/* SEO CONTENT */}
        <p style={subtitle}>
          Compare top bike loan providers in India including HDFC Bank, Axis Bank,
          Bajaj Finance, and IDFC First Bank. Find the lowest interest rates,
          fastest approval, and flexible EMI options to finance your dream bike.
        </p>

        <div style={grid}>
          <LoanCard name="HDFC Bank" rate="8.5%" approval="24 Hours" link="#" />
          <LoanCard name="Bajaj Finance" rate="9%" approval="Instant" link="#" />
          <LoanCard name="Axis Bank" rate="8.75%" approval="48 Hours" link="#" />
          <LoanCard name="IDFC First Bank" rate="8.6%" approval="Fast Approval" link="#" />
        </div>
      </div>
    </>
  );
}

function LoanCard({ name, rate, approval, link }) {
  return (
    <div style={card}>
      <h3>{name}</h3>
      <p>Interest Rate: {rate}</p>
      <p>Approval: {approval}</p>

      <button style={btn} onClick={() => window.open(link)}>
        Apply Now
      </button>
    </div>
  );
}

/* styles */
const title = { fontSize: "28px", marginBottom: "10px" };
const subtitle = { color: "#aaa", marginBottom: "20px", lineHeight: "1.6" };

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: "20px",
};

const card = {
  background: "#111",
  padding: "20px",
  borderRadius: "12px",
  border: "1px solid #222",
};

const btn = {
  marginTop: "10px",
  padding: "10px",
  width: "100%",
  background: "#ff4d00",
  border: "none",
  borderRadius: "8px",
  color: "#fff",
  cursor: "pointer",
};